<template>
  <ResourceErrorState
    kind="notFound"
    :back-to="homePath"
    back-label="Vissza a főoldalra"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import ResourceErrorState from "@/components/layout/ResourceErrorState.vue";
import { useAuthStore } from "@/store/AuthStore";
import { portalHomeFor } from "@/utils/routeAccess";

/**
 * The catch-all, and the page a customer gets when they open an /admin/... URL. Rendered at the
 * URL the user typed or was sent, rather than redirecting home: a silent redirect reads as "you
 * navigated wrong" when the truth is usually a dead link, and it takes away the broken URL they
 * would have shown support.
 *
 * Home comes from the role, not the path. On an /admin/... URL the path would send a customer
 * to a portal they cannot open — one dead end handing them another.
 */
const authStore = useAuthStore();
const homePath = computed(() => portalHomeFor(authStore.role) ?? "/");
</script>
